export default "__VITE_ASSET__B$uRgUhO__"